__turbopack_context__.v({
  "active": "subnavigation-module-scss-module__L-mr4q__active",
  "container": "subnavigation-module-scss-module__L-mr4q__container",
  "item": "subnavigation-module-scss-module__L-mr4q__item",
  "placeholder": "subnavigation-module-scss-module__L-mr4q__placeholder",
  "scroll-container": "subnavigation-module-scss-module__L-mr4q__scroll-container",
});
